export default "__VITE_ASSET__CUfltE6H__"